/**
 * Стакан Polymarket на карточке: глубина asks, доллары под наш кэф.
 *
 * Ордер отсюда не уходит — человек жмёт Buy на их сайте.
 */

import type { ReactElement } from 'react';
import { Decimal } from 'decimal.js';

import type { BookLevel } from '../lib/calc';
import { paintAsks } from '../poly/market';

const money = (value: Decimal): string => value.toDecimalPlaces(2, Decimal.ROUND_DOWN).toFixed(2);
const cents = (value: Decimal): string => value.times(100).toDecimalPlaces(1, Decimal.ROUND_HALF_UP).toString();

export function PolyBookLadder({
  asks,
  usd,
  ourPrice: _ourPrice,
  live: _live,
  at: _at,
  eat,
  say,
  warn: _warn,
}: {
  asks: readonly BookLevel[] | null;
  usd: number | null | undefined;
  ourPrice: number | null;
  live: boolean;
  at: number | null;
  eat: boolean;
  say?: string | null;
  warn?: string | null;
}): ReactElement {
  if (asks === null || asks.length === 0) {
    return <div className="nx-depth">{say ?? 'стакан ещё не пришёл'}</div>;
  }
  const want = usd ?? 0;
  const wantDec = new Decimal(Math.max(0, want));
  const filling = eat && wantDec.gt(0);
  const rungs = paintAsks(asks, filling ? want : 0, 4);
  const widest = rungs.reduce((max, rung) => (rung.usd.gt(max) ? rung.usd : max), new Decimal(0));
  return (
    <div className="nx-depth">
      <ol className="nx-depth__ask">
        {rungs.map((rung) => {
          const depth = widest.gt(0) ? rung.usd.div(widest).times(100).toDecimalPlaces(1).toNumber() : 0;
          return (
            <li key={rung.price.toString()} className={rung.take ? 'take' : undefined}>
              <b>{cents(rung.price)} ¢</b>
              <span className="nx-depth__bar" aria-hidden="true">
                <i style={{ width: `${Math.min(100, depth)}%` }} />
              </span>
              <em>{money(rung.usd)} $</em>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
